import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89282688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-frame" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "User Name", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "URL", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Error Type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Annotation" }, "Annotation", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Manual Contents" }, "Manual Contents", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Video" }, "Video", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1))
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Feedback", -1))

import { reactive, onMounted } from "vue";
import { useStore } from "@/store";
import { api } from "@/service/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;



const store = useStore();

const formdata = reactive({
  username: "anonymous",
  email: "",
  url: "",
  errortype: "Other",
  message: "",
});



const hideModal = async () => {
  emit("close");
};

const submit = async (e) => {
  e.preventDefault();

  const res = await api.post("/feedback", formdata);

  if (res.status < 300) {
    alert("Form submitted. Thank you for your feedback.");
    formdata.message = "";
    hideModal();
  } else {
    alert(res.data);
  }

  return false;
};

onMounted(() => {
  formdata.username = store.user?.displayName as string || "anonymous";
  formdata.email = store.user?.email || "";
  formdata.url = window.location.href;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-background", { 'show-modal': props.show }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      false
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Feedback"))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formdata.username) = $event))
            }, null, 512), [
              [_vModelText, formdata.username]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formdata.email) = $event))
            }, null, 512), [
              [_vModelText, formdata.email]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formdata.url) = $event))
            }, null, 512), [
              [_vModelText, formdata.url]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formdata.errortype) = $event))
            }, _hoisted_13, 512), [
              [_vModelSelect, formdata.errortype]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formdata.message) = $event)),
            placeholder: "Please Enter You're Feedback"
          }, null, 512), [
            [_vModelText, formdata.message]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "buttons" }, [
        _createElementVNode("button", {
          class: "submit",
          onClick: submit
        }, "Submit"),
        _createElementVNode("button", {
          class: "cancel",
          onClick: hideModal
        }, "Cancel")
      ])
    ])
  ], 2))
}
}

})